module.exports = __webpack_public_path__ + "img/step2-mobile-en@2x.fed590b9.webp";